import { render } from "./eventDetails.vue?vue&type=template&id=abbb22be"
import script from "./eventDetails.vue?vue&type=script&lang=js"
export * from "./eventDetails.vue?vue&type=script&lang=js"

import "./eventDetails.vue?vue&type=style&index=0&id=abbb22be&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__